import React from 'react';
import './nfdFontsSection.scss';
import { ReactComponent as PoppinsFont } from "./components/Poppins.svg";
import { ReactComponent as NotoLoopedThaiFont } from "./components/NotoLoopedThai.svg";

const NfdFontsSection = () => {
	return (
		<div className="nfdFonts">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="nfdFonts__content">
				<div className="nfdFonts__content_title">
					<h2>NFD Fonts</h2>
				</div>
				<div className="nfdFonts__content_data">
					<div className="nfdFonts__content_data_item">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<div className="nfdFonts__content_data_item_block">
							<PoppinsFont />
						</div>
						<button
							className="nfdFonts__content_data_item_btn"
							onClick={() => window.open('https://fonts.google.com/specimen/Poppins?preview.text=Poppins')}
						>
							<span>Open in Google Font</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
								<path d="M1.25 8.75L8.75 1.25" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
								<path d="M1.25 1.25H8.75" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
								<path d="M8.75 1.25V8.75" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
							</svg>
						</button>
					</div>
					<div className="nfdFonts__content_data_item">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<div className="nfdFonts__content_data_item_block">
							<NotoLoopedThaiFont />
						</div>
						<button
							className="nfdFonts__content_data_item_btn"
							onClick={() => window.open('https://fonts.google.com/noto/specimen/Noto+Sans+Thai+Looped?preview.text=Noto%20Sans%20Thai%20Looped')}
						>
							<span>Open in Google Font</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
								<path d="M1.25 8.75L8.75 1.25" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
								<path d="M1.25 1.25H8.75" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
								<path d="M8.75 1.25V8.75" stroke="#D6B0FF" strokeWidth="1.5" strokeLinecap="round"/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NfdFontsSection;